export default function AOClpCountdown() {
  let $days = null;
  let $daysLabel = null;
  let $hours = null;
  let $hoursLabel = null;
  let $minutes = null;
  let $seconds = null;

  const initiate = () => {
    let timeLeft = Math.abs($('.js-ao-clp-countdown-timer').data('time'));
    $daysLabel = $('.js-ao-clp-countdown-block__label-days');
    $hoursLabel = $('.js-ao-clp-countdown-block__label-hours');

    $days = $('.js-ao-clp-countdown-timer .js-clp-countdown-block__timer-days');
    $hours = $('.js-ao-clp-countdown-timer .js-clp-countdown-block__timer-hours');
    $minutes = $('.js-ao-clp-countdown-timer .js-clp-countdown-block__timer-minutes');
    $seconds = $('.js-ao-clp-countdown-timer .js-clp-countdown-block__timer-seconds');

    const interval = setInterval(() => {
      timeLeft -= 1;
      if (timeLeft > 0) {
        const days = Math.floor(timeLeft / 86400);
        const hours = Math.floor((timeLeft - days * 86400) / 3600);
        const minutes = Math.floor((timeLeft - days * 86400 - hours * 3600) / 60);
        const seconds = timeLeft - days * 86400 - hours * 3600 - minutes * 60;

        $days.text(days);
        $hours.text(hours);
        $minutes.text((minutes < 10 ? '0' : '') + minutes);
        $seconds.text((seconds < 10 ? '0' : '') + seconds);

        $daysLabel.text(days === 1 ? 'DAY' : 'DAYS');
        $hoursLabel.text(hours === 1 ? 'HOUR' : 'HOURS');
      } else {
        $days.text('0');
        $hours.text('0');
        $minutes.text('00');
        $seconds.text('00');
        clearInterval(interval);
      }
    }, 1000);
  };

  return { initiate };
}
